export default "__VITE_ASSET__CDbLfFfm__"